import { GetServerSideProps } from "next";
import type { Session } from "next-auth";
import { getSession } from "next-auth/react";
import Head from "next/head";

import LandingPageComponent from "../components/Home/LandingPage/Home";
import HomeComponent from "../components/Home/SignedIn/Home";
import SignedInLayout from "../components/Layouts/Navbar/SignedIn/SignedInLayout";

export default function Home({ session }: { session: Session | null }) {
  if (!session) {
    return <LandingPageComponent />;
  }

  return (
    <SignedInLayout session={session}>
      <Head>
        <title>WinShopCRM</title>
      </Head>
      <main>{session && <HomeComponent session={session} />}</main>
    </SignedInLayout>
  );
}

export const getServerSideProps: GetServerSideProps<{
  session: Session | null;
}> = async (context) => {
  return {
    props: {
      session: await getSession(context),
    },
  };
};
